export interface RPESubActividad {
  actividad_id: number, 
  tipo_subactividad_id: number,
  especies_id: number []
}

export function createEmptyRPESubActividad(): RPESubActividad {
  return {
    actividad_id: null, 
    tipo_subactividad_id: null,
    especies_id: null
  };
}

export function createRPESubActividad(props: any): RPESubActividad {
  return {
    ...createEmptyRPESubActividad(),
    ...props
  };
}